<template>
    <div class="n2-center-container">
        <div id="n3-account-orders" style="position: relative;">
            <div style="">
                <a @click="$router.go(-1)" class="n2-link-back">
                    <div style="display: flex; align-items:center;">
                        <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                        <span style="margin-left:5px;">
                            {{ $t('pages.account.order.back') }}
                        </span>
                    </div>
                </a>
            </div>
            <h5 class="n2-text-center">{{ $t('pages.account.orders.title') }}</h5>
            <app-loader v-bind:active="loading"></app-loader>
            <pager v-on:page-changed="navToPage($event)" v-bind:page_number="page_number" v-bind:page_size="page_size"
                v-bind:total_size="total_size"></pager>
            <div style="margin-top: 20px;" v-if="orders && orders.length > 0">
                <table class="order-list" style="width:100%;" cellspacing="0" cellpadding="0">
                    <template class="order" v-for="order in orders">
                        <tr class="order-header" v-bind:key="order">
                            <td colspan="3" class="n2-row">
                                <div class="order-cell">
                                    <div class="col-md-2 order-text">{{ $t('pages.account.orders.order_time') }}:
                                        {{ getLocalDateString(order.locale, order.created_at, 'short') }}
                                        {{ getLocalTimeString(order.locale, order.created_at) }}
                                    </div>
                                    <div class="col-md-2 order-text">{{ $t('pages.account.orders.booking_number') }}:
                                        {{ order.booking_number }}</div>
                                    <div class="col-md-2 order-text">{{ $t('pages.account.orders.total') }}: {{
                                        formatNumber(order.locale,
                                            order.ticket_total) }}&nbsp;NOK
                                    </div>
                                    <div class="col-md-2 order-text">{{ $t('pages.account.orders.status') }}:
                                        <template v-if="order.status == 'open'">{{
                                            $t('pages.account.orders.status_open')
                                            }}</template>
                                        <template v-if="order.status == 'closed'">{{
                                            $t('pages.account.orders.status_closed')
                                            }}</template>
                                        <template v-if="order.status == 'cancelled'">{{
                                            $t('pages.account.orders.status_cancelled')
                                            }}</template>
                                    </div>
                                    <div class="col-md-4 n2-text-right order-text">
                                        <a v-bind:href="`/${app_locale}/account/orders/${order.id}?order_token=${encodeURIComponent(order.token || '')}`">{{
                                            $t('pages.account.orders.detail') }}</a>
                                        <a href="#" v-on:click.prevent="download(order)">{{
                                            $t('pages.account.orders.pdf')
                                            }}</a>
                                        <a href="#" v-on:click.prevent="openCancelModal(order)">{{
                                            $t('pages.account.orders.cancel')
                                            }}</a>
                                        <a href="#" v-on:click.prevent="openChangeModal(order)">{{
                                            $t('pages.account.orders.change')
                                            }}</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <template class="leg" v-for="leg in order.legs">
                            <tr v-bind:key="leg">
                                <td colspan="3">
                                    <div class="order-cell leg_summary">
                                        <span style="margin-right:10px; font-weight:bold;">{{
                                            getDateString(order.locale,
                                                leg.steps[0].transit.local_depart_at, 'long') }}</span>
                                        <span>{{ getWeekday(order.locale, leg.steps[0].transit.local_depart_at)
                                            }}</span>

                                        <span v-if="leg.status == 'cancelled' && leg.cancelled_at"
                                            class="text_cancelled">
                                            {{ $t('pages.account.orders.cancelled_at') }}:&nbsp;{{
                                                getLocalTimeStringLong(order.locale, leg.cancelled_at) }}
                                        </span>
                                    </div>
                                </td>
                            </tr>
                            <template v-for="step in leg.steps">
                                <tr class="transit" v-if="step.travel_mode == 'transit'" v-bind:key="step"
                                    v-bind:class="{ text_cancelled: leg.status == 'cancelled' }">
                                    <td>
                                        <div class="order-cell">
                                            <span>{{ getLocalDateString(order.locale, step.transit.depart_at, 'short')
                                                }}</span>&nbsp;
                                            <span style="font-weight:bold;">{{ getLocalTimeString(order.locale,
                                                step.transit.depart_at) }}</span>&nbsp;
                                            <span style="display:inline-block">{{ step.transit.departure_stop.name
                                                }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="order-cell">
                                            <span>{{ getLocalDateString(order.locale, step.transit.arrive_at, 'short')
                                                }}</span>&nbsp;
                                            <span style="font-weight:bold;">{{ getLocalTimeString(order.locale,
                                                step.transit.arrive_at) }}</span>&nbsp;
                                            <span style="display:inline-block">{{ step.transit.arrival_stop.name
                                                }}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="order-cell"></div>
                                    </td>
                                </tr>
                            </template>
                        </template>
                    </template>
                </table>
            </div>
            <div v-else>
                <div class="n2-text-center" v-if="!loading">
                    {{ $t('pages.account.orders.no_order') }}
                </div>
            </div>
            <div class="n2-padding"> </div>
            <pager v-on:page-changed="navToPage($event)" v-bind:page_number="page_number" v-bind:page_size="page_size"
                v-bind:total_size="total_size"></pager>








        </div>

        <div id="n1-cancel-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:800px;position:relative;">

                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>

                <div class="">
                    <div style="padding: 10px;">
                        <div>
                            <app-content name="web.term.cancellation"></app-content>
                        </div>
                    </div>
                    <order-cancellation v-bind:order="selected_order"
                        v-on:cancelled="orderCancelled($event)"></order-cancellation>
                </div>
            </div>
        </div>
        <div id="n1-change-modal" class="w3-modal">
            <div class="w3-modal-content w3-card-4" style="max-width:800px;position:relative;">

                <span v-on:click="closeModal" style="position:absolute; right:0;" class="n2-close n2-close-40"></span>

                <div class="">
                    <div style="padding: 10px;">
                        <div>
                            <app-content name="web.term.change"></app-content>
                        </div>
                    </div>
                    <div style="padding: 10px;">
                        <order-change v-if="selected_order" v-bind:entity="selected_order"
                            v-on:cancelled="orderCancelled($event)"></order-change>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AccountService, OrderService } from '../services'
import AppLoader from '../components/shared/loader.vue'
import Pager from '../components/shared/pager.vue'
import OrderCancellation from '../components/app/order-cancellation.vue'
import OrderChange from '../components/app/order-change.vue'
import AppContent from '../components/shared/content.vue';



export default {
    components: {
        AppLoader, Pager, OrderCancellation, AppContent, OrderChange
    },
    data: function () {
        return {
            orders: [],
            loading: false,
            page_number: 1,
            page_size: 10,
            selected_order: null,
            success: false,
        }
    },
    computed: {
        ...mapGetters('globalization', [
            'app_locale',
        ]),
        ...mapGetters('identity', [
            'user',
        ]),
    },

    created: function () {
        this.accountService = new AccountService()
        this.orderService = new OrderService()

    },
    mounted: async function () {
        await this.search();
    },
    methods: {
        getDateString: function (locale, source, format) { return new Date(source).toLocaleString(locale, { dateStyle: format }); },
        getLocalTimeString: function (locale, source) { return new Date(source.substr(0, 19) + 'Z').toLocaleString(locale, { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Oslo' }); },
        getLocalDateString: function (locale, source, format) { return new Date(source.substr(0, 19) + 'Z').toLocaleString(locale, { dateStyle: format, timeZone: 'Europe/Oslo' }); },
        formatNumber: function (locale, source) { return Number(source).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); },
        getWeekday: function (locale, source) { return new Date(source).toLocaleString(locale, { weekday: 'long' }); },
        getLocalTimeStringLong: function (locale, source) { return new Date(source.substr(0, 19) + 'Z').toLocaleString(locale == 'en-US' ? 'en-GB' : locale, { timeZone: 'Europe/Oslo' }); },

        download: async function (order) {
            this.loading = true
            try {
                let pdf = await this.orderService.getPdf(order.id, order.template, order.token)
                const file = new Blob(
                    [pdf],
                    { type: 'application/pdf' });
                var url = window.URL.createObjectURL(file)
                var a = document.createElement('a')
                a.href = url
                a.download = order.booking_number
                a.click()
                a.remove()
                setTimeout(() => window.URL.revokeObjectURL(url), 100)
            }
            finally {
                this.loading = false
            }
        },

        navToPage: function (page_number) {
            this.page_number = page_number;
            this.search();
        },
        search: async function () {
            try {
                this.loading = true
                let response = await this.accountService.getOrders({ page_number: this.page_number, page_size: this.page_size });
                this.orders = response.data;
                this.total_size = response.total_size;
                this.query.page_number = response.page_number;
            } catch (e) {
                this.error = e;
            }
            finally {
                this.loading = false;
            }
        },
        openChangeModal: function (order) {
            this.selected_order = order;
            document.getElementById('n1-change-modal').style.display = 'block';
        },
        openCancelModal: function (order) {
            this.selected_order = order;
            document.getElementById('n1-cancel-modal').style.display = 'block';
        },
        orderCancelled: function (order) {
            this.replaceObjectWithValue(this.orders, order.booking_number, order);
            this.selected_order = order;
        },
        replaceObjectWithValue: function (array, targetValue, newObject) {
            const index = array.findIndex(obj => obj.booking_number === targetValue);

            if (index !== -1) {
                array.splice(index, 1, newObject);
            }
        },

        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },
    }
}
</script>
